export const agentTemplates = [
  {
    id: 1,
    name: "Customer Support Agent",
    category: "Service",
    description: "Handle customer inquiries with context awareness and sentiment analysis. Supports escalation protocols.",
    tags: ["Customer Service", "NLP", "Multi-language", "Sentiment Analysis"],
    price: "Free",
    popularity: 4.8,
    downloads: 1247,
    industries: ["Retail", "SaaS", "E-commerce"],
    longDescription: "This advanced customer support agent leverages natural language processing and sentiment analysis to provide intelligent, context-aware responses to customer inquiries. Built with enterprise-grade security and multi-language support, it seamlessly integrates with existing customer service platforms.",
    features: [
      "24/7 automated customer support",
      "Sentiment analysis and escalation triggers",
      "Multi-language support (50+ languages)",
      "Integration with CRM systems",
      "Custom knowledge base training",
      "Real-time analytics and reporting"
    ],
    techSpecs: {
      "Model Type": "Large Language Model + NLP Pipeline",
      "Response Time": "< 200ms average",
      "Accuracy": "94.5% customer satisfaction",
      "Integrations": "Salesforce, HubSpot, Zendesk, Slack",
      "Security": "SOC 2 Type II, GDPR compliant",
      "Languages": "50+ supported languages"
    },
    usageStats: {
      "Monthly Active Users": "15.2K",
      "Messages Processed": "2.4M",
      "Average Rating": "4.8/5",
      "Response Accuracy": "94.5%"
    },
    setupTime: "15 minutes",
    lastUpdated: "2 days ago"
  },
  {
    id: 2,
    name: "Data Analysis Agent",
    category: "Analytics",
    description: "Automated data processing, visualization, and insight generation from structured and unstructured data.",
    tags: ["Data Processing", "Visualization", "SQL", "Python"],
    price: "Pro",
    popularity: 4.6,
    downloads: 892,
    industries: ["Finance", "Healthcare", "Manufacturing"],
    longDescription: "Transform raw data into actionable insights with this powerful data analysis agent. Combines automated data processing, advanced visualization, and machine learning to generate comprehensive reports and recommendations.",
    features: [
      "Automated data pipeline creation",
      "Advanced statistical analysis",
      "Interactive dashboard generation",
      "Anomaly detection and alerting",
      "Predictive modeling capabilities",
      "Export to multiple formats"
    ],
    techSpecs: {
      "Model Type": "ML Pipeline + Statistical Engine",
      "Processing Speed": "1GB/minute data processing",
      "Accuracy": "96.2% prediction accuracy",
      "Integrations": "SQL databases, AWS, GCP, Tableau",
      "Security": "End-to-end encryption",
      "Formats": "CSV, JSON, SQL, Parquet, Excel"
    },
    usageStats: {
      "Monthly Active Users": "8.7K",
      "Data Processed": "450TB",
      "Average Rating": "4.6/5",
      "Insights Generated": "125K"
    },
    setupTime: "30 minutes",
    lastUpdated: "1 week ago"
  },
  {
    id: 3,
    name: "Content Moderation Agent",
    category: "Security",
    description: "Real-time content analysis and policy enforcement with customizable moderation rules.",
    tags: ["Content Moderation", "Policy Enforcement", "Real-time"],
    price: "Enterprise",
    popularity: 4.9,
    downloads: 634,
    industries: ["Social Media", "Gaming", "Education"]
  },
  {
    id: 4,
    name: "Supply Chain Optimizer",
    category: "Operations",
    description: "Optimize inventory levels, predict demand, and automate procurement decisions across supply chain.",
    tags: ["Supply Chain", "Demand Forecasting", "Automation"],
    price: "Pro",
    popularity: 4.7,
    downloads: 445,
    industries: ["Manufacturing", "Retail", "Logistics"]
  },
  {
    id: 5,
    name: "Financial Risk Assessor",
    category: "Finance",
    description: "Automated credit scoring, fraud detection, and risk assessment for financial institutions.",
    tags: ["Risk Assessment", "Fraud Detection", "Credit Scoring"],
    price: "Enterprise",
    popularity: 4.8,
    downloads: 567,
    industries: ["Banking", "Insurance", "Fintech"]
  },
  {
    id: 6,
    name: "HR Recruitment Assistant",
    category: "HR",
    description: "Automate resume screening, candidate matching, and interview scheduling with bias reduction.",
    tags: ["Recruitment", "Resume Screening", "Bias Reduction"],
    price: "Free",
    popularity: 4.5,
    downloads: 789,
    industries: ["Technology", "Consulting", "Healthcare"]
  },
  {
    id: 7,
    name: "Legal Document Analyzer",
    category: "Legal",
    description: "Contract analysis, compliance checking, and legal document summarization with regulatory awareness.",
    tags: ["Contract Analysis", "Compliance", "Document Processing"],
    price: "Enterprise",
    popularity: 4.6,
    downloads: 234,
    industries: ["Legal", "Real Estate", "Finance"]
  },
  {
    id: 8,
    name: "Marketing Campaign Optimizer",
    category: "Marketing",
    description: "Optimize ad campaigns, A/B test variations, and personalize customer experiences at scale.",
    tags: ["Campaign Optimization", "A/B Testing", "Personalization"],
    price: "Pro",
    popularity: 4.4,
    downloads: 678,
    industries: ["E-commerce", "Media", "SaaS"]
  }
];